interface Element<Item> {
    item: Item;
    prev: Element<Item> | null;
    next: Element<Item> | null;
}

class LinkedListClass<Item> {
    private length = 0;
    private first: Element<Item> | null = null;
    private last: Element<Item> | null = null;

    public empty(): this is EmptyLinkedList<Item> {
        return this.length === 0;
    }

    public notEmpty(): this is NonEmptyLinkedList<Item> {
        return this.length > 0;
    }

    public clear(): void {
        this.length = 0;
        this.first = null;
        this.last = null;
    }

    public forEach(fn: (item: Item) => void): void {
        let current = this.first;
        while (current !== null) {
            fn(current.item);
            current = current.next;
        }
    }

    public push(item: Item): void {
        this.length++;
        const last = this.last;
        const element = { prev: last, next: null, item: item };
        if (last) {
            last.next = element;
        } else {
            this.first = element;
        }
        this.last = element;
    }

    public shift(this: NonEmptyLinkedList<Item>): Item;
    public shift(this: EmptyLinkedList<Item>): undefined;
    public shift(): Item | undefined;
    public shift(): Item | undefined {
        if (!this.first) {
            return undefined;
        }
        this.length--;
        const element = this.first;
        if (this.last === element) {
            this.first = null;
            this.last = null;
        } else {
            this.first = element.next;
            // @ts-expect-error last !== element => element.next !== null
            this.first.prev = null;
        }
        return element.item;
    }
}

declare const State: unique symbol;
type EmptyLinkedList<Item> = LinkedListClass<Item> & { readonly [State]: "empty" };
type NonEmptyLinkedList<Item> = LinkedListClass<Item> & { readonly [State]: "nonempty" };

export type LinkedList<Item> = EmptyLinkedList<Item> | NonEmptyLinkedList<Item>;

interface LinkedListCtor {
    new <Item>(): LinkedList<Item>;
}

export const LinkedList = LinkedListClass as LinkedListCtor;
